<template>
  <div :class="`as-incident ${classname}`">
     <div
        v-for="(incident, incidentKey) in incidentData"
        :key="incidentKey"
        :class="`as-incident-item as-incident-item-${incident.type}`"
      >
        <component
          v-if="getIncidentIcon(incident)"
          :is="getIncidentIcon(incident)"
        />
        <span v-if="[9].includes(incident.type)"  class="as-time">{{ incident.time }}'</span>
        <span v-else-if="[1].includes(incident.type) && incident.count > 1"  class="as-count">{{ incident.count }}</span>
      </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import MatchEnum from "~src/enums/MatchEnum";
import type { IIncident, IPlayer, IIncidentStatistic } from "~src/interfaces";

interface IProps {
  player: IPlayer;
  types: number[];
  classname: string;
}

const props = withDefaults(defineProps<IProps>(), {
  types: [1, 3, 4, 8, 9, 15, 17],
  classname: ''
});

const listIncidents: IIncidentStatistic[] = MatchEnum.INCIDENT_LIST;

const incidentData = computed(() => {
  const incidents: IIncident[] = [];
  for(const incident of props.player.incidents) {
    if(!props.types.includes(incident.type)) continue;

    if(incident.type === 1) {
      // Bàn thắng
      if (incident?.player?.id === props.player.id) {
        const index = incidents.findIndex((item: IIncident) => item.type === 1 && item?.player?.id === props.player.id);
        if(index === -1) {
          incidents.push({
            ...incident,
            count: 1
          });
        } else {
          incidents[index].count = incidents[index].count + 1;
        }
      }

      // Kiến tạo
      if (incident?.assist1?.id === props.player.id) {
        const index = incidents.findIndex((item: IIncident) => item.type === 1 && item?.assist1?.id === props.player.id);
        if(index === -1) {
          incidents.push({
            ...incident,
            count: 1
          });
        } else {
          incidents[index].count = incidents[index].count + 1;
        }
      }
    } else {
      incidents.push(incident);
    }
  }

  return incidents;
})

const getIncidentIcon = (incident: IIncidentStatistic | IIncident) => {
  const inci: IIncidentStatistic | undefined = listIncidents.find(
    (item: IIncidentStatistic) => item.type === incident.type
  );

  if (inci && props.types.includes(inci.type)) {
    // Kiến tạo
    if (inci.type === 1 && incident?.player?.id !== props.player.id) {
      const inci1: IIncidentStatistic | undefined = listIncidents.find(
        (item: IIncidentStatistic) => item.type === 1111
      );

      return inci1?.icon;
    }
    // else if (inci.type === 9 && incident?.out_player?.id === props.player.id) {
    //   const inci1: IIncidentStatistic | undefined = listIncidents.find(
    //     (item: IIncidentStatistic) => item.type === 10
    //   );

    //   return inci1?.icon;
    // }

    return inci.icon;
  }

  return null;
};
</script>

<script lang="ts">
export default {};
</script>
